module.exports = __webpack_public_path__ + "static/media/logo.6224289f.svg";